import downloadIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/download.svg";
import minusIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/minus.svg";
import userIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import workplaceIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/workplace.svg";
import plusIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/plus.svg";
import atTheRate from "../../../assests/HPE/enterpriseone/ent-a/icons/@.svg";
import barChart from "../../../assests/HPE/enterpriseone/ent-a/icons/bar-chart.svg";
import tree from "../../../assests/HPE/enterpriseone/smb-a/tree.svg";
import questionMark from "../../../assests/HPE/enterpriseone/ent-a/icons/question-mark.svg";
import phoneIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/phone.svg";
import square from "../../../assests/HPE/enterpriseone/ent-a/icons/square.svg";
import checkbox from "../../../assests/HPE/enterpriseone/ent-a/icons/checkbox.svg";
import EnterpriseInput from "./EnterpriseInput";
import { useEffect, useState } from "react";
import DocumentPreview from "./DocumentPreview";
import { object, string } from "yup";
import axios from "../../../config";
import { Link, useNavigate } from "react-router-dom";
import CardHeader from "./CardHeader";
import document1 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-1.webp";
import document2 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-2.webp";
import document3 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-3.webp";
import XIcon from "../../../assests/HPE/enterpriseone/ent-a/icons/x.svg";

import SelectV2 from "../../common/SelectV2";

import { useStatsigClient } from "@statsig/react-bindings";
import { useTrackEvent } from "../../../hooks/useTrackEvent";

const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const countryDialCodeMap = {
  Australia: "+61",
  Austria: "+43",
  Canada: "+1",
  Finland: "+358",
  France: "+33",
  Germany: "+49",
  "Hong Kong": "+852",
  India: "+91",
  Indonesia: "+62",
  Ireland: "+353",
  Japan: "+81",
  Malaysia: "+60",
  Netherlands: "+31",
  "New Zealand": "+64",
  Philippines: "+63",
  Singapore: "+65",
  "South Korea": "+82",
  Taiwan: "+886",
  Thailand: "+66",
  "United States": "+1",
  Vietnam: "+84",
};

const phoneRegexByCountry = {
  Australia: /^\d{9,10}$/,
  Austria: /^\d{10,13}$/,
  Canada: /^\d{10}$/,
  Finland: /^\d{9,12}$/,
  France: /^\d{9}$/,
  Germany: /^\d{10,13}$/,
  "Hong Kong": /^\d{8}$/,
  India: /^\d{10}$/,
  Indonesia: /^\d{9,12}$/,
  Ireland: /^\d{9}$/,
  Japan: /^\d{10,11}$/,
  Malaysia: /^\d{9,10}$/,
  Netherlands: /^\d{9}$/,
  "New Zealand": /^\d{8,10}$/,
  Philippines: /^\d{10}$/,
  Singapore: /^\d{8}$/,
  "South Korea": /^\d{9,10}$/,
  Taiwan: /^\d{9}$/,
  Thailand: /^\d{9}$/,
  "United States": /^\d{10}$/,
  Vietnam: /^\d{9,10}$/,
};

const countryOptions = [
  "Australia",
  "Austria",
  "Canada",
  "Finland",
  "France",
  "Germany",
  "Hong Kong",
  "India",
  "Indonesia",
  "Ireland",
  "Japan",
  "Malaysia",
  "Netherlands",
  "New Zealand",
  "Philippines",
  "Singapore",
  "South Korea",
  "Taiwan",
  "Thailand",
  "United States",
  "Vietnam",
];

const validationSchema = object({
  first_name: string().trim().required("Please enter your full name"),
  email: string()
    .trim()
    .matches(emailRegExp, "Please enter a valid email")
    .required("Please enter an email"),
  company: string().trim().required("Please enter your company name"),
  country: string(),
  phone: string().test(
    "valid-phone-by-country",
    "",
    function validatePhoneByCountry(value) {
      const trimmedValue = value?.trim();
      const { country } = this.parent;

      if (!trimmedValue) return true;

      if (!country) {
        return this.createError({
          path: "country",
          message: "Please select your country",
        });
      }

      const phoneRegex = phoneRegexByCountry[country];
      if (phoneRegex && !phoneRegex.test(trimmedValue)) {
        return this.createError({
          path: "phone",
          message: `Phone number is not valid for ${country}`,
        });
      }

      return true;
    },
  ),
});

const challengeOptions = [
  "VMware costs and licensing",
  "Hybrid cloud management across multiple environments",
  "IT operations visibility and alert overload",
  "Application provisioning speed",
  "All of the above",
];

const environmentsOptions = [
  "On-prem only",
  "On-prem plus one public cloud",
  "Multi-cloud (2 or more clouds)",
  "Mixed including containers and bare metal",
];

const vmwareContractStatusOptions = [
  "Renewal coming up in under 12 months",
  "Already renewed under Broadcom pricing",
  "Actively evaluating alternatives",
  "Not currently on VMware",
];

const ResourcesFrom = ({
  showPreview = true,
  isPopup = false,
  initialFullName = "",
  showCurrentChallenge = false,
  showEnterpriseTwoSelects = false,
  onClose,
  buttonText = "Download the resource pack instantly",
  formLocation,
  statsigDesignId,
}) => {
  const navigate = useNavigate();
  const { client } = useStatsigClient();
  const [name, setName] = useState(initialFullName);
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [challenge, setChallenge] = useState("");
  const [environments, setEnvironments] = useState("");
  const [vmwareContractStatus, setVmwareContractStatus] = useState("");
  const [termsCheck, setTermsCheck] = useState(false);
  const [termsCheckError, setTermsCheckError] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOptional, setShowOptional] = useState(false);
  const docs = [
    { img: document2, title: "GigaOm Radar", pages: "52 pages · PDF" },
    {
      img: document3,
      title: "AstraZeneca Customer Story",
      pages: "4 pages · PDF",
    },
    { img: document1, title: "IDC Spotlight", pages: "8 pages · PDF" },
  ];

  const trackEvent = useTrackEvent();

  const submitTackEvent = () => {
    trackEvent(
      {
        event: "lead_ent",
        form_location: formLocation,
        statsig_design_id: statsigDesignId,
      },
      { once: true },
    );
  };

  useEffect(() => {
    setName(initialFullName || "");
  }, [initialFullName]);

  function showErrors(validationErrors) {
    const newErrors = {};
    validationErrors.forEach((error) => {
      newErrors[error.path] = error.message;
    });
    setErrors(newErrors);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await validationSchema.validate(
        { first_name: name, email, company, phone, country },
        { abortEarly: false },
      );
      setErrors({});

      if (!termsCheck) {
        setTermsCheckError(true);
        setIsSubmitting(false);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const utm_source = params.get("utm_source") || "";
      const utm_medium = params.get("utm_medium") || "";
      const utm_campaign = params.get("utm_campaign") || "";
      const allChallengesText = challengeOptions
        .filter((option) => option !== "All of the above")
        .join("|");
      const currentChallengeValue =
        challenge === "All of the above" ? allChallengesText : challenge;
      const formattedPhone = phone
        ? `${countryDialCodeMap[country] || ""} ${phone}`.trim()
        : "";

      const payload = {
        first_name: name,
        last_name: "",
        email,
        company,
        designation: "",
        estimated_budget: "-",
        role_in_decision_making: "-",
        expected_procurement_timeline: "-",
        is_there_a_budget: "-",
        is_there_a_requirement: "-",
        current_challenge: currentChallengeValue,
        environments,
        vmware_contract_status: vmwareContractStatus,
        phone: formattedPhone,
        country,
        utm_campaign,
        utm_medium,
        utm_source,
      };

      await axios.post("/hybrid-cloud/submit-form", payload);
      submitTackEvent();
      // firing event to statsig to indicate form submission
      client.logEvent("form_submitted", "homepage");

      navigate("/thank-you");
    } catch (error) {
      if (error.inner) {
        showErrors(error.inner);
      } else {
        console.log("Error: ", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="w-full  py-12 bg-navy-blue-01 bg-enterprise-pattern">
      {isPopup && (
        <img
          src={XIcon}
          alt=""
          onClick={onClose}
          className="absolute right-4 top-4 md:top-4 w-5 h-5 text-white cursor-pointer"
        />
      )}
      {/* <div className="flex flex-col gap-10 md:gap-16 items-center text-center max-w-[1128px] mx-auto"> */}
      <div className="flex flex-col gap-10 md:gap-16 max-w-[1188px] mx-auto px-4 sm:px-6 md:px-10">
        {/* Heading */}
        <CardHeader
          title="Access the free HPE Hybrid Cloud resource pack"
          description="Analyst report, case study and ebook included. Plus 0% financing
            details and a complimentary infrastructure assessment."
        />

        {/* MAIN SECTION */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 w-full">
          {/* LEFT - FORM */}
          <form
            className="flex flex-col gap-6 md:gap-8 w-full md:flex-1"
            onSubmit={handleSubmit}
          >
            {/* Inputs */}
            <div className="flex flex-col gap-5">
              {/* Name */}
              <EnterpriseInput
                icon={userIcon}
                type="text"
                placeholder="Full name*"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrors((prev) => ({ ...prev, first_name: "" }));
                }}
                error={errors.first_name}
              />

              {/* Email + Company */}
              <div className="flex flex-col lg:flex-row gap-5 w-full">
                <div className="w-full">
                  <EnterpriseInput
                    icon={atTheRate}
                    type="text"
                    placeholder="Work email*"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }}
                    className="w-full"
                    error={errors.email}
                  />
                </div>

                <div className="w-full">
                  <EnterpriseInput
                    icon={workplaceIcon}
                    type="text"
                    placeholder="Company name*"
                    value={company}
                    onChange={(e) => {
                      setCompany(e.target.value);
                      setErrors((prev) => ({ ...prev, company: "" }));
                    }}
                    className="w-full"
                    error={errors.company}
                  />
                </div>
              </div>

              {/* Optional Fields */}
              {showOptional && (
                <div className="flex flex-col gap-5 w-full">
                  <div className="flex flex-col lg:flex-row gap-5 w-full">
                    <div className="w-full">
                      <SelectV2
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            country: "",
                            phone: "",
                          }));
                        }}
                        icon={workplaceIcon}
                        error={errors.country}
                      >
                        <option value="">Select country</option>
                        {countryOptions.map((option) => (
                          <option
                            key={option}
                            value={option}
                            className="text-black"
                          >
                            {option}
                          </option>
                        ))}
                      </SelectV2>
                    </div>

                    <div className="w-full">
                      <EnterpriseInput
                        icon={phoneIcon}
                        type="text"
                        placeholder="Phone no."
                        value={phone}
                        disabled={!country}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /\D/g,
                            "",
                          );
                          setPhone(numericValue);
                          setErrors((prev) => ({ ...prev, phone: "" }));
                        }}
                        className="w-full"
                        error={errors.phone}
                      />
                    </div>
                  </div>

                  {showCurrentChallenge && (
                    <>
                      {/* <div className="flex h-[46px] p-3 items-center gap-2.5 flex-1 rounded-lg border border-navy-blue-04 bg-navy-blue-05">
                        <select
                          value={challenge}
                          onChange={(e) => setChallenge(e.target.value)}
                          className="bg-transparent outline-none w-full text-grey-03"
                        >
                          <option value="">Biggest current challenge</option>
                          {challengeOptions.map((option) => (
                            <option
                              key={option}
                              value={option}
                              className="text-black"
                            >
                              {option}
                            </option>
                          ))}
                        </select>
                      </div> */}
                      <SelectV2
                        value={challenge}
                        onChange={(e) => setChallenge(e.target.value)}
                        icon={barChart}
                      >
                        <option value="" disabled>
                          Biggest current challenge
                        </option>
                        {challengeOptions.map((option) => (
                          <option
                            key={option}
                            value={option}
                            className="text-black"
                          >
                            {option}
                          </option>
                        ))}
                      </SelectV2>
                    </>
                  )}

                  {showEnterpriseTwoSelects && (
                    <>
                      <SelectV2
                        value={environments}
                        onChange={(e) => setEnvironments(e.target.value)}
                        icon={tree}
                      >
                        <option value="" disabled>
                          How many environments does your team currently manage?
                        </option>
                        {environmentsOptions.map((option) => (
                          <option
                            key={option}
                            value={option}
                            className="text-black"
                          >
                            {option}
                          </option>
                        ))}
                      </SelectV2>

                      <SelectV2
                        value={vmwareContractStatus}
                        onChange={(e) =>
                          setVmwareContractStatus(e.target.value)
                        }
                        icon={questionMark}
                      >
                        <option value="" disabled>
                          What is your current VMware contract status?
                        </option>
                        {vmwareContractStatusOptions.map((option) => (
                          <option
                            key={option}
                            value={option}
                            className="text-black"
                          >
                            {option}
                          </option>
                        ))}
                      </SelectV2>
                    </>
                  )}
                </div>
              )}

              {/* Toggle Optional */}
              <div
                onClick={() => setShowOptional((prev) => !prev)}
                className="flex items-center gap-2 text-grey-03 cursor-pointer"
              >
                <img
                  src={showOptional ? minusIcon : plusIcon}
                  className="w-4 h-4"
                  alt=""
                />
                <p className="font-inter">
                  {showOptional ? "Hide optional" : "Show optional"}
                </p>
              </div>
            </div>

            {/* Checkbox */}
            <div>
              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  name="terms-and-condition"
                  id="terms-and-condition"
                  checked={termsCheck}
                  onChange={(e) => {
                    setTermsCheck(e.target.checked);
                    setTermsCheckError(!e.target.checked);
                  }}
                  className="hidden"
                />
                <img
                  src={termsCheck ? checkbox : square}
                  alt=""
                  className="w-4 h-4 mt-0.5 cursor-pointer flex-shrink-0"
                  onClick={() => {
                    setTermsCheck((prev) => !prev);
                    setTermsCheckError(termsCheck);
                  }}
                />
                <p className="text-grey-03 text-[14px] leading-[22px] font-normal font-inter text-start">
                  By submitting this form, I confirm I have read and agree to
                  the Computechoice.com{" "}
                  <Link to="/terms">
                    <span className="font-normal underline">
                      Terms of Use
                    </span>{" "}
                  </Link>
                  and{" "}
                  <Link to="/privacy-policy">
                    <span className="font-normal underline">
                      Privacy Policy
                    </span>
                  </Link>
                  . I authorise Computechoice.com to contact me with information
                  about HPE products and services relevant to my enquiry.
                </p>
              </div>
              {termsCheckError && (
                <p className="text-red text-xs text-start">
                  Please mark the above checkbox
                </p>
              )}
            </div>

            {/* Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full p-3 rounded-lg bg-blue font-inter hover:bg-blue-01 active:bg-blue-02 text-white text-[14px] leading-[22px] font-medium disabled:opacity-70"
            >
              {isSubmitting ? "Submitting..." : buttonText}
            </button>
            <div className="flex items-center gap-2 self-stretch">
              <div className="">
                <img
                  src={downloadIcon}
                  className="w-[14px] h-[14px] color-green"
                  alt=""
                />
              </div>

              <p className="text-grey-03 flex-1 text-[10px] leading-[18px] md:text-[12px] md:leading-[20px] font-medium text-start font-inter">
                <span className="text-green">Downloads immediately.</span> No
                sales call unless you want one.
              </p>
            </div>
          </form>

          {/* RIGHT - PREVIEW */}
          {showPreview && (
            <div className={`w-full max-w-[320px] sm:max-w-[384px] mx-auto `}>
              <DocumentPreview documents={docs} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ResourcesFrom;
